import { render, staticRenderFns } from "./PsGroupsDetailUpperBar.vue?vue&type=template&id=1522444c&scoped=true&"
import script from "./PsGroupsDetailUpperBar.vue?vue&type=script&lang=js&"
export * from "./PsGroupsDetailUpperBar.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsDetailUpperBar.vue?vue&type=style&index=0&id=1522444c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522444c",
  null
  
)

export default component.exports